import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-loadscreen',
  templateUrl: './loadscreen.component.html',
  styleUrls: ['./loadscreen.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgClass
  ]
})
export class LoadscreenComponent {

  @Input() text: string = 'Loading...'
  @Input() fullscreen: boolean = true

  constructor() { }
}
